import { ref } from 'vue';
import type { ToastType } from '@/common/components/ui/toast/EMToast.vue';

interface ToastState {
  visible: boolean;
  message: string;
  type: ToastType;
}

const state = ref<ToastState>({
  visible: false,
  message: '',
  type: 'success',
});

export function useToast() {
  const show = (message: string, type: ToastType = 'success') => {
    state.value = { visible: true, message, type };
  };

  const hide = () => {
    state.value.visible = false;
  };

  return {
    toastState: state,
    showToast: show,
    hideToast: hide,
  };
}
